module.exports = __webpack_public_path__ + "static/media/Bollodorado.add948d4.jpg";